import { centsToDollarsNumber } from '../../../lib/util';
import type { TFunction } from 'i18next';
import i18next from '../../../../i18n';

export function getNumberSuffix(numString: string, t: TFunction) {
  const num = parseInt(numString);

  const th = t('ordinal_suffix_th');
  const rd = t('ordinal_suffix_rd');
  const nd = t('ordinal_suffix_nd');
  const st = t('ordinal_suffix_st');

  if (num === 11 || num === 12 || num === 13) return th;

  const lastDigit = num.toString().slice(-1);

  switch (lastDigit) {
    case '1':
      return st;
    case '2':
      return nd;
    case '3':
      return rd;
    default:
      return th;
  }
}

export function getBillingCadenceDescription(
  priceInCents: number,
  renewalMonths: number,
  currencyFormatter: Intl.NumberFormat,
) {
  const price = currencyFormatter.format(centsToDollarsNumber(priceInCents));
  if (renewalMonths === 1) {
    return i18next.t('price_per_month', { price });
  } else if (renewalMonths % 12 === 0) {
    const years = Math.round(renewalMonths / 12);
    if (years === 1) {
      return i18next.t('price_per_year', { price });
    } else if (years === 2) {
      return i18next.t('price_per_biennially', { price });
    } else {
      return i18next.t('price_per_years_years', { price, years });
    }
  }
  return i18next.t('price_per_months_months', { price, months: renewalMonths });
}

/**
 * Returns a string for referencing a membership in a title, e.g. "6 months"
 */
export function getShortSubscriptionName(t: TFunction, renewalMonths: number) {
  if (renewalMonths === 1) {
    return t('monthly');
  } else if (renewalMonths % 12 === 0) {
    const years = Math.round(renewalMonths / 12);
    if (years === 1) {
      return t('1_year');
    } else {
      return t('years_years', { years });
    }
  }
  return t('months_months', { months: renewalMonths });
}

/**
 * Returns a string for referencing a membership in a sentence, e.g. "You have a **6 month** membership"
 */
export function getShortSubscriptionDescription(t: TFunction, renewalMonths: number) {
  if (renewalMonths === 1) {
    return t('monthly');
  } else if (renewalMonths % 12 === 0) {
    const years = Math.round(renewalMonths / 12);
    return t('year_year', { years });
  }
  return t('month_month', { months: renewalMonths });
}
